import {
  SIDE_NAV_LIGHT,
  NAV_TYPE_SIDE,
  DIR_LTR,
} from "constants/ThemeConstant";
import { env } from "./EnvironmentConfig";

export const APP_NAME = "Lensman";
export const COMPANY_NAME = "";
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const CDN_BASE_URL = env.CDN_ENDPOINT_URL;
export const YT_BASE_URL = env.YT_URL;
export const APP_PREFIX_PATH = "";
export const AUTH_PREFIX_PATH = "";
export const AES_ENCRYPTION_KEY = env.AES_KEY;
export const AES_ENCRYPTION_IV_KEY = env.AES_ENCRYPTION_IV;
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards`;
export const PHOTOGRAPHER_AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/qr-code`;
export const UNAUTHENTICATED_ENTRY = "/login";

export const CURRENCY_CODE = "app_currency_code_98f3b1d2";
export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: "en",
  navType: NAV_TYPE_SIDE,
  topNavColor: "#3e82f7",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: "light",
  direction: DIR_LTR,
  blankLayout: false,
};
